import { inject, Injectable } from '@angular/core';
import { type CreateCardTaskInput, type UpdateCardTaskInput } from '@reconcept-platform/shared/types';
import { TaskApi } from '../../api/task/task.api';
import { type CardTaskStatusEnum } from '../../schema/schema-enums';

@Injectable({
  providedIn: 'root',
})
export class TaskService {
  private taskApi = inject(TaskApi);

  watchGoalTasksWithUsers(goalCardIds: string[], status: CardTaskStatusEnum[]) {
    return this.taskApi.watchGoalCardTasksWithUsers(goalCardIds, status);
  }

  watchEventTasksWithUsers(eventCardIds: string[], status: CardTaskStatusEnum[]) {
    return this.taskApi.watchEventCardTasksWithUsers(eventCardIds, status);
  }

  createTask(createCardTaskInput: CreateCardTaskInput) {
    return this.taskApi.createCardTask(createCardTaskInput);
  }

  updateTask(cardId: string, updateCardTaskInput: UpdateCardTaskInput) {
    return this.taskApi.updateCardTask(cardId, updateCardTaskInput);
  }
}
